import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { TopupStatus, TopupType } from '@/models/features/communication'

import { useInvalidateGiftCardTopups } from './get-gift-card-topups'

type UpdateGiftCardTopupStatusRequest = {
  buildingId: number
  topupId: number
  status: Exclude<TopupStatus, 'pending'>
  type: TopupType
  amount: number
}

type UpdateGiftCardTopupStatusResponse = {
  balance: number
}

const updateGiftCardTopupStatus = async ({
  buildingId,
  ...body
}: UpdateGiftCardTopupStatusRequest) => {
  const response = await authAPI.post<UpdateGiftCardTopupStatusResponse>(
    `/reward/building/${buildingId}/topup`,
    body,
  )
  return response.data
}

export const useUpdateGiftCardTopupStatus = () => {
  const invalidateGiftCardTopups = useInvalidateGiftCardTopups()

  return useMutation({
    mutationFn: updateGiftCardTopupStatus,
    onSuccess: invalidateGiftCardTopups,
  })
}
